import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

export const menuItemSelectedStyle = css`
  &.Mui-focusVisible,
  &.Mui-selected {
    background-color: var(--s-info-light);
  }
`;

export const classes = {
  listItem: cn(
    'h-36 p-12 flex items-center space-s-12 hover:bg-s-info-light rounded-8',
    menuItemSelectedStyle,
  ),
};

export const POPOVER_MAX_HEIGHT = 20;

export const emojiPopperStyles = css`
  min-width: 30rem;
  max-width: 30rem;
  z-index: 1300;
  max-height: ${POPOVER_MAX_HEIGHT}rem;
`;
